"use strict";const s="collapsing";exports.collapsingClass=s;
//# sourceMappingURL=collapsingClass-CLblascz.js.map
